import { render, staticRenderFns } from "./_TaskResponsible.vue?vue&type=template&id=5fc1dd65&scoped=true&"
import script from "./_TaskResponsible.vue?vue&type=script&lang=js&"
export * from "./_TaskResponsible.vue?vue&type=script&lang=js&"
import style0 from "./_TaskResponsible.vue?vue&type=style&index=0&id=5fc1dd65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc1dd65",
  null
  
)

export default component.exports